import { render } from "./ViewerPaymentPlan.vue?vue&type=template&id=f4b770a8&scoped=true"
import script from "./ViewerPaymentPlan.vue?vue&type=script&lang=ts"
export * from "./ViewerPaymentPlan.vue?vue&type=script&lang=ts"

import "./ViewerPaymentPlan.vue?vue&type=style&index=0&id=f4b770a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f4b770a8"

export default script